import { render, staticRenderFns } from "./uploadVedio.vue?vue&type=template&id=b6e7474e&scoped=true&"
import script from "./uploadVedio.vue?vue&type=script&lang=js&"
export * from "./uploadVedio.vue?vue&type=script&lang=js&"
import style0 from "./uploadVedio.vue?vue&type=style&index=0&id=b6e7474e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e7474e",
  null
  
)

export default component.exports